export default __webpack_public_path__ + "static/guest_onboarding-9c63a6620324521f9243a5a8ef943a5f.svg";